<template>
  <div class="OrderCanceled">
      <div class="OrderCanceled__header">
        <div class="OrderCanceled__header__left">
          <div class="OrderCanceled__header__left__search">
            <i class="adx-ic_search"></i>
            <input type="text" placeholder="Search" class="search" v-model="searchBoxValue">
          </div>
        </div>
        <div class="OrderCanceled__header__right">
          <p>Sort by :</p>
          <div>
            <adx-dropdown-sort  :labelButton="`All Filter`"
            :value.sync="selectedSortValue" :type="true" :options="sort"></adx-dropdown-sort>
          </div>
        </div>
      </div>
      
      <adx-table text="Tooltip button" 
        :items.sync="data" 
        :loading.sync="isLoading"
        :isEmpty.sync="isEmpty">
      </adx-table>

      <div class="total_order" v-if="!isLoading && !isEmpty">{{getDataRange}} of {{count}} Orders</div>
      <adx-pagination 
        v-if="!isLoading && !isEmpty"
        @change-page="changePage"
        :max-page="maxPage"
        :selected-page="currentPage"
      />
    </div>
</template>

<script>
import Loading from '@/components/Loading/Primary'
import Pagination from '@/components/Pagination'
import DropdownSort from '@/components/Form/SelectDropdown'
import table from '@/components/Table'
import LabelStatus from '@/components/StatusLabel'
import Dropdown2Level from '@/components/Dropdown/Dropdown2Level'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { helpers } from '@/lib/validation/'

export default {
  name: 'adx-canceled-order',
  components: {
    'adx-loading': Loading,
    'adx-pagination': Pagination,
    'adx-dropdown-sort': DropdownSort,
    'adx-table': table, LabelStatus,
    'dropdown-2-level': Dropdown2Level
  },
  props: {

  },
  data() {
    return {
      item: null,
      items: [],
      selectedItems:[],
      currentPage: 1,
      count: 0,
      maxPage: 1,
      searchBoxValue: '',
      selectedSortValue: 'last_updated',
      sort: [
        {
          'id': 0,
          'label': 'Created Date',
          'value': 'first_added'
        },
        {
          'id': 1,
          'label': 'Last Updated',
          'value': 'last_updated'
        },
        {
          'id': 2,
          'label': 'Price High to Low',
          'value': '-price'
        },
        {
          'id': 3,
          'label': 'Price Low to High',
          'value': 'price'
        },
      ],
      data: {
        checkbox: false,
        head: [
          {
            title: "ID",
            type: "text-value"
          },
          {
            title: "COMPANY NAME",
            type: "text"
          },
          {
            title: "CAMPAIGN NAME",
            type: "text"
          },
          {
            title: "STATUS",
            type: "statuslabel"
          },
          {
            title: "PRICE",
            type: "money"
          },
          {
            title: "PAYMENT",
            type: "statuslabel"
          },
          {
            title: "START DATE",
            type: "date"
          },
          {
            title: "CREATED",
            type: "date"
          },
          {
            title: "LAST UPDATED",
            type: "date"
          },
        ],
        body: []
      },
    }
  },
  apollo:{
    busOrdersPage:{
      query:require('@/graphql/bus/query/busOrdersPage.gql'),
      variables(){
        return{
          page: this.currentPage.toString() || "1",
          orderStatus: undefined,
          channelStatus: undefined,
          campaignStatus: "3",
          sort: this.selectedSortValue || undefined,
          search: this.searchBoxValue || undefined
        }
      },
      loadingKey:'loading',
      result(data){
        const {busOrdersPage} = data.data
        let result = []
        let busOrders = busOrdersPage.busOrders
        let meta = busOrdersPage.meta
        for(let i = 0; i<busOrders.length;i++){
          let statusDisplay = this.getStatusDisplay(busOrders[i].status.titleDisplay)
          let campaignStat = this.getCampaignStat(busOrders[i].campaign.statusDisplay)
          let valuesData = [
            { label: busOrders[i].number, value: busOrders[i].id },
            { value: busOrders[i].campaign.companyName},
            { value: busOrders[i].campaign.title},
            { value: campaignStat, label: campaignStat.toUpperCase() },
            { value: parseInt(busOrders[i].campaign.totalPrice ) || 0},
            { value: busOrders[i].payment.statusDisplay.toLowerCase(), label: busOrders[i].payment.statusDisplay.toUpperCase() },
            { value: busOrders[i].campaign.start},
            { value: busOrders[i].campaign.createdAt},
            { value: busOrders[i].campaign.UpdateAt},
          ]
          result.push({values:valuesData})
        }
        this.data.body = result
        this.maxPage = meta.maxPage
        this.count = meta.count
      }
    }
  },
  computed: {
    getFilterParams: function () {
      const params = {
        sort: this.selectedSortValue || undefined,
        search: this.searchBoxValue || undefined
      }
      return params
    },
    getDataRange: function(){
      return (this.count%15===0 || this.currentPage===1) && this.count>15?this.currentPage*15:(this.currentPage*15-15)+(this.count%15)
    },
    isEmpty: function(){
      return this.data.body && this.data.body.length? false: true
    },
    isLoading: function(){
      return this.$apollo.loading || false
    }
  },
  watch: {
    searchBoxValue: helpers.debounce(function (){
      this.$nextTick(function(){
        this.currentPage = 1
        this.$apollo.queries.busOrdersPage.refetch()
      })
    }, 500),
    selectedSortValue: function(newVal, oldVal){
      if(newVal!=oldVal){
        this.currentPage = 1
        this.selectedSortValue = newVal
        this.$apollo.queries.busOrdersPage.refetch()
      }
    }
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    const { page } = this.$route.query
    if(page){
      this.currentPage = parseInt(page)
    }
    this.$apollo.queries.busOrdersPage.refetch()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    resetData(){
      this.data.body = []
    },
    changePage (selected) {
      history.pushState(null, null, '?page=' + selected);
      this.currentPage = selected
      this.$apollo.queries.busOrdersPage.refetch()
    },
    toDetailPage(itemID) {
      this.$router.push({name: 'orderdetailexecution', params: { id: itemID }})
    },
    getCampaignStat(stat){
      let status = "cancel"
      switch (stat) {
        case `Draft`:
          status = "draft"
          break;
        case `Verifying`:
          status = "verifying"
          break;
        case `Active`:
          status = "active"
          break;
        case `Cancel`:
          status = "canceled"
          break;
        case `Expired`:
          status = "expired"
          break;
        case `Deleted`:
          status = "deleted"
          break;
        case `Dormant`:
          status = "dormant"
          break;      
      }
      return status
    },
    getStatusDisplay(status){
      let state = status.toLowerCase()
      let res = []
      switch(state){
        case `lead`:
          res = { id: 0, value: 'lead', label: 'LEAD', status: ''}
          break
        case `verifying`:
          res = { id: 1, value: 'verifying', label: 'VERIFYING', status: 'verified'}
          break
        case `designing`:
          res = { id: 2, value: 'designing', label: 'DESIGNING', status: 'verified'}
          break
        case `designapproval`:
          res = { id: 3, value: 'designapproval', label: 'DESIGN APPROVAL', status: 'designed'}
          break
        case `printing`:
          res = { id: 4, value: 'printing', label: 'PRINTING', status: 'designed'}
          break
        case `printapproval`:
          res = { id:5, value: 'printapproval', label: 'PRINTING APPROVAL', status: 'designed'}
          break
        case `wrapping`:
          res = { id:6, value: 'wrapping', label: 'WRAPPING', status:'designed'}
          break
        case `done`:
          res = { id:7, value: 'done', label: 'DONE', status:'wrapped'}
      }
      return res
    },
    resetData(){
      this.data.body = []
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang='scss'>
.OrderCanceled {
  .table {
    table {
      thead {
        tr {
          background-color: #fafafa;
          td {
            span {
              font-size:12px;
            }
          }
        }
      }
      tbody {
        tr {
          td {
            .text {
              font-size:15px;
              max-width: 200px;
              -webkit-line-clamp: 3;
            }
            .date {
              font-size:15px;
            }
            .money {
              text-align:left;
              span {
                font-size:15px;
              }
            }
          }
        }
      }
    }
	}
}
.standardInput {
  font-size: 15px
}
</style>